import { ThemeKey } from "@smartsheet/design-tokens";
import React, { HTMLAttributes } from "react";
import { useTheme } from "../../../../theme/utils/useTheme";
import { InputFieldBaseProps } from "../../../../util/inputFieldBaseProps";
import { selectBasicFontTheme } from "../selectV2Theme";
import { SelectPlaceholderStyled } from "./SelectPlaceholderStyled";

interface SelectPlaceholderProps extends InputFieldBaseProps, HTMLAttributes<HTMLDivElement> {
    hasContentBefore: boolean;
}

export const SelectPlaceholder = ({ children, hasContentBefore, ...rest }: SelectPlaceholderProps) => {
    const { key } = useTheme();
    const themeMode = key as ThemeKey;

    return (
        <SelectPlaceholderStyled
            themeMode={themeMode}
            // @ts-expect-error variant type is complaining
            variant={selectBasicFontTheme.variant(themeMode)}
            lineClamp={1}
            aria-hidden={true}
            hasContentBefore={hasContentBefore}
            {...rest}
        >
            {children}
        </SelectPlaceholderStyled>
    );
};
